(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hanogram-home-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hg-home-slideshow')) {
  customElements.define('hg-home-slideshow', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const on = (el, name, fn) => el.addEventListener(name, fn, {signal:this.abort.signal});
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.index = 0;
      this.paused = this.dataset.autoplay !== 'true' || matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.hover = false;
      this.editing = false;
      this.controls = this.querySelector('.hg-slideshow-controls');
      const dots = this.querySelector('[data-dots]');
      dots.replaceChildren();
      this.slides.forEach((slide, i) => {
        const dot = document.createElement('button');
        dot.type = 'button'; dot.dataset.dot = String(i);
        dot.setAttribute('aria-label', this.querySelector('[data-dot-label]').content.textContent + ' ' + (i + 1));
        on(dot, 'click', () => this.show(i)); dots.append(dot);
      });
      this.dots = Array.from(dots.children);
      this.controls.hidden = this.slides.length < 2;
      this.pauseButton = this.querySelector('[data-pause]');
      on(this.querySelector('[data-prev]'), 'click', () => this.show(this.index - 1));
      on(this.querySelector('[data-next]'), 'click', () => this.show(this.index + 1));
      on(this.pauseButton, 'click', () => {this.paused = !this.paused; this.schedule();});
      on(this, 'mouseenter', () => {this.hover = true; this.schedule();});
      on(this, 'mouseleave', () => {this.hover = false; this.schedule();});
      on(this, 'focusin', () => this.schedule());
      on(this, 'focusout', () => setTimeout(() => this.schedule(), 0));
      on(document, 'visibilitychange', () => this.schedule());
      on(this, 'touchstart', e => {this.touchX = e.changedTouches[0].clientX; this.touchY = e.changedTouches[0].clientY;});
      on(this, 'touchend', e => {const dx = e.changedTouches[0].clientX - this.touchX; const dy = e.changedTouches[0].clientY - this.touchY; if(Math.abs(dx)>50 && Math.abs(dx)>Math.abs(dy)) this.show(this.index + (dx<0?1:-1));});
      on(document, 'shopify:block:select', e => {const i=this.slides.findIndex(s=>s.dataset.blockId===e.detail.blockId); if(i>=0){this.editing=true;this.show(i);}});
      on(document, 'shopify:block:deselect', () => {this.editing=false;this.schedule();});
      this.dataset.ready = ''; this.show(0);
    }
    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide,i) => {slide.classList.toggle('is-active', i===this.index);slide.setAttribute('aria-hidden', String(i!==this.index));slide.inert=i!==this.index;this.dots[i].setAttribute('aria-current', String(i===this.index));});
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      this.pauseButton.textContent = this.paused ? '▶' : 'Ⅱ';
      this.pauseButton.setAttribute('aria-label', this.paused ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel);
      if(this.slides.length>1 && !this.paused && !this.hover && !this.editing && !document.hidden && !this.contains(document.activeElement)) this.timer=setTimeout(()=>this.show(this.index+1), Number(this.dataset.interval)||4000);
    }
    disconnectedCallback(){clearTimeout(this.timer);this.abort.abort();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hanogram-mobile-menu"]) return;
  try {
    
(() => {
  const menu = document.getElementById('han-mobile-menu');
  if (!menu || typeof menu.showModal !== 'function') return;
  const mobile = window.matchMedia('(max-width:767px)');
  let opener;
  let priorOverflow;
  document.addEventListener('click', event => {
    const trigger = event.target.closest('.mainmenumob-js');
    if (!trigger || !mobile.matches) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (menu.open) return;
    opener = trigger;
    priorOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    menu.showModal();
    menu.querySelector('.han-menu__close').focus();
  }, true);
  menu.querySelector('.han-menu__close').addEventListener('click', () => menu.close());
  menu.addEventListener('click', event => {
    if (event.target !== menu) return;
    const box = menu.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) menu.close();
  });
  menu.addEventListener('close', () => {
    document.body.style.overflow = priorOverflow || '';
    if (opener) opener.focus();
  });
  menu.querySelector('select').addEventListener('change', event => {
    if (event.target.value) window.location.assign(event.target.value);
  });
  mobile.addEventListener('change', () => { if (!mobile.matches && menu.open) menu.close(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-fixed"]) return;
  try {
    
  function initPromoFixed(){
    var $ttpromofixed = $(".tt-promo-fixed"),
    	$promofixeddata = $(".promofixeddata"),
        $promofixedclose = $ttpromofixed.find(".tt-btn-close");
    
    if($('html').hasClass('touch-device') && $ttpromofixed.hasClass('hidden-mobile')) return false;
	if($ttpromofixed.hasClass('hidden-mobile') && $(window).width < 1025) return false;
    if($promofixeddata.length == 0) return false;
    
    setPromoFixedItem($ttpromofixed, $promofixeddata);
	showPromoFixed($ttpromofixed, $ttpromofixed.data('start'));
    
	showPromoFixedNextMessage($ttpromofixed, $promofixeddata, $promofixedclose)

    $promofixedclose.click(function(){
      $ttpromofixed.addClass('nonevent').fadeTo(100, 0);
    });
  }
  function showPromoFixedNextMessage($modal, $data, $close){
    var nextmin = $modal.data('min'),
        nextmax = $modal.data('max');
	var i = getRndInteger(nextmin, nextmax);
    setTimeout(function(){
      $close.trigger('click');
      setTimeout(function(){
        setPromoFixedItem($modal, $data);
        showPromoFixed($modal, 0);
        showPromoFixedNextMessage($modal, $data, $close);
      }, 100);
    }, i);
  }
  function getPromoFixedCustomProductIndex($promofixeddata){
    var min = 0,
        max = $promofixeddata.children().length;
    return getRndInteger(min, max);
  }
  function setPromoFixedItem($modal, $data){
    var i = getPromoFixedCustomProductIndex($data)
    var data = $data.children().eq(i);
    $modal.find('.tt-img').find('a').attr('href', data.data('url')).find('img').attr('src', data.data('image')).attr('alt', data.data('alt'));
    $modal.find('.pr_name').attr('href', data.data('url')).text(data.data('name'));
    
    var nummin = parseInt(data.data('min')),
    	nummax = parseInt(data.data('max')),
    	num = getRndInteger(nummin, nummax);
    $modal.find('.tt-info-value').text(num);

	if (typeof data.data('text') === typeof undefined) return false;
    var str = data.data('text').split('||'),
    	i = getRndInteger(0, str.length-1);
    $modal.find('.tt-info-text').text(str[i]);
  }
  function showPromoFixed($parent, delay){
    setTimeout(function(){
	  $parent.removeClass('nonevent').fadeTo(300, 1);
    }, delay);
  }
  function getRndInteger(min, max) {
    return Math.floor(Math.random() * (max - min) ) + min;
  }
  setTimeout(initPromoFixed, 300);

  } catch(e) { console.error(e); }
})();
})();
